export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";